import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as VarietyServices from "../../../../services/VarietyService";
import { useTranslation } from "react-i18next";
import VarietyForm from "./varietyForm.view";
import PATHS from "../../../../constants/paths";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const VarietyFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});

  const setInitialValues = useCallback(async (data) => {
    const dataFinal = {
      name: data.name,
      active: data.active,
      culture: data.culture,
    };
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    if (uuid) {
      const result = await VarietyServices.getVariety(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        if (uuid) {
          result = await VarietyServices.updateVariety(values, uuid);
        } else {
          result = await VarietyServices.addVariety(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.variety.messages.update.title");
            text = t("forms.variety.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.variety.messages.create.title");
            text = t("forms.variety.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.variety.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.VARIETY_LIST);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.VARIETY_LIST);
  };

  return (
    <VarietyForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onback={handleOnback}
    />
  );
};

VarietyFormContainer.propTypes = {
  t: PropTypes.any,
};

export default VarietyFormContainer;
